import React from "react";
import { useMountEffect } from "tsi-common-react/src/hooks/useMountEffect";
import { preferredLocationSelector } from "tsi-common-react/src/store/common/selectors";
import { useAppDispatch } from "tsi-common-react/src/store/reducers";

import { useAppSelector } from "../../../hooks";
import { flagshipStoreSelector } from "../selectors";
import { loadAllFlagshipStorePages } from "../thunks";
import { FlagshipNearestStores as FlagshipNearestStoresComponent } from "./FlagshipNearestStoresContent";

export const FlagshipNearestStores = (props: {
    maxTiles: number;
    includeLocationInfo: boolean;
}): React.ReactNode => {
    const stores = useAppSelector(flagshipStoreSelector);
    const storePages = useAppSelector((state) =>
        Object.values(state.retail.flagshipStorePages),
    );
    const preferredLocation = useAppSelector(preferredLocationSelector);
    const dispatch = useAppDispatch();

    useMountEffect(() => {
        void dispatch(loadAllFlagshipStorePages());
    });

    return (
        <FlagshipNearestStoresComponent
            stores={stores}
            storePages={storePages}
            maxTiles={props.maxTiles}
            preferredLocation={preferredLocation}
            includeLocationInfo={props.includeLocationInfo}
        />
    );
};
